export const UPDATE_TRACKING_STATUS_REQUEST = "UPDATE_TRACKING_STATUS_REQUEST";
export const UPDATE_TRACKING_STATUS_SUCCESS = "UPDATE_TRACKING_STATUS_SUCCESS";
export const UPDATE_TRACKING_STATUS_ERROR = "UPDATE_TRACKING_STATUS_ERROR";

export const FETCH_TRACKING_STATUS_REQUEST = "FETCH_TRACKING_STATUS_REQUEST";
export const FETCH_TRACKING_STATUS_SUCCESS = "FETCH_TRACKING_STATUS_SUCCESS";
export const FETCH_TRACKING_STATUS_ERROR = "FETCH_TRACKING_STATUS_ERROR";

export const ADD_INSTRUCTIONS_REQUEST = "ADD_INSTRUCTIONS_REQUEST";
export const ADD_INSTRUCTIONS_SUCCESS = "ADD_INSTRUCTIONS_SUCCESS";
export const ADD_INSTRUCTIONS_FAILURE = "ADD_INSTRUCTIONS_FAILURE";

export const FETCH_REQUIRED_DOCUMENTS_REQUEST =
  "FETCH_REQUIRED_DOCUMENTS_REQUEST";
export const FETCH_REQUIRED_DOCUMENTS_SUCCESS =
  "FETCH_REQUIRED_DOCUMENTS_SUCCESS";
export const FETCH_REQUIRED_DOCUMENTS_FAILURE =
  "FETCH_REQUIRED_DOCUMENTS_FAILURE";

export const ALL_COUNTRIES_REQUEST = "ALL_COUNTRIES_REQUEST";
export const ALL_COUNTRIES_SUCCESS = "ALL_COUNTRIES_SUCCESS";
export const ALL_COUNTRIES_FAILURE = "ALL_COUNTRIES_FAILURE";

export const FETCH_DOCUMENT_TYPE_INSTRUCTION_REQUEST =
  "FETCH_DOCUMENT_TYPE_INSTRUCTION_REQUEST";
export const FETCH_DOCUMENT_TYPE_INSTRUCTION_SUCCESS =
  "FETCH_DOCUMENT_TYPE_INSTRUCTION_SUCCESS";
export const FETCH_DOCUMENT_TYPE_INSTRUCTION_FAILURE =
  "FETCH_DOCUMENT_TYPE_INSTRUCTION_FAILURE";

export const FETCH_ALL_INSTRUCTIONS_REQUEST = "FETCH_ALL_INSTRUCTIONS_REQUEST";
export const FETCH_ALL_INSTRUCTIONS_SUCCESS = "FETCH_ALL_INSTRUCTIONS_SUCCESS";
export const FETCH_ALL_INSTRUCTIONS_FAILURE = "FETCH_ALL_INSTRUCTIONS_FAILURE";

export const FETCH_USER_DOCUMENTS_REQUEST = "FETCH_USER_DOCUMENTS_REQUEST";
export const FETCH_USER_DOCUMENTS_SUCCESS = "FETCH_USER_DOCUMENTS_SUCCESS";
export const FETCH_USER_DOCUMENTS_FAILURE = "FETCH_USER_DOCUMENTS_FAILURE";

export const FETCH_DOCUMENT_LIST_REQUEST = "FETCH_DOCUMENT_LIST_REQUEST";
export const FETCH_DOCUMENT_LIST_SUCCESS = "FETCH_DOCUMENT_LIST_SUCCESS";
export const FETCH_DOCUMENT_LIST_FAILURE = "FETCH_DOCUMENT_LIST_FAILURE";

export const FETCH_DOCUMENT_REQUEST = "FETCH_DOCUMENT_REQUEST";
export const FETCH_DOCUMENT_SUCCESS = "FETCH_DOCUMENT_SUCCESS";
export const FETCH_DOCUMENT_FAILURE = "FETCH_DOCUMENT_FAILURE";

export const PROCESS_DOCUMENT_REQUEST = "PROCESS_DOCUMENT_REQUEST";
export const PROCESS_DOCUMENT_SUCCESS = "PROCESS_DOCUMENT_SUCCESS";
export const PROCESS_DOCUMENT_FAILURE = "PROCESS_DOCUMENT_FAILURE";

export const DOCUMENT_APPROVAL_REQUEST = "DOCUMENT_APPROVAL_REQUEST";
export const DOCUMENT_APPROVAL_SUCCESS = "DOCUMENT_APPROVAL_SUCCESS";
export const DOCUMENT_APPROVAL_FAILURE = "DOCUMENT_APPROVAL_FAILURE";

export const PROCESSING_FEE_REQUEST = "PROCESSING_FEE_REQUEST";
export const PROCESSING_FEE_SUCCESS = "PROCESSING_FEE_SUCCESS";
export const PROCESSING_FEE_FAILURE = "PROCESSING_FEE_FAILURE";

export const FETCH_ATTACHED_DOCUMENT_REQUEST =
  "FETCH_ATTACHED_DOCUMENT_REQUEST";
export const FETCH_ATTACHED_DOCUMENT_SUCCESS =
  "FETCH_ATTACHED_DOCUMENT_SUCCESS";
export const FETCH_ATTACHED_DOCUMENT_FAILURE =
  "FETCH_ATTACHED_DOCUMENT_FAILURE";

export const ATTACH_DOCUMENT_REQUEST = "ATTACH_DOCUMENT_REQUEST";
export const ATTACH_DOCUMENT_SUCCESS = "ATTACH_DOCUMENT_SUCCESS";
export const ATTACH_DOCUMENT_FAILURE = "ATTACH_DOCUMENT_FAILURE";

export const DELETE_ATTACHED_DOCUMENT_REQUEST =
  "DELETE_ATTACHED_DOCUMENT_REQUEST";
export const DELETE_ATTACHED_DOCUMENT_SUCCESS =
  "DELETE_ATTACHED_DOCUMENT_SUCCESS";
export const DELETE_ATTACHED_DOCUMENT_FAILURE =
  "DELETE_ATTACHED_DOCUMENT_FAILURE";
